(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-forklift-checkbox"] && !Shopify.designMode) return;
  try {
    class CartAttributeCheckbox extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.hiddenInput = this.querySelector('input[type="hidden"]');
      this.onChange = this.onChange.bind(this);
      this.checkbox?.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      this.checkbox?.removeEventListener('change', this.onChange);
    }

    onChange() {
      const key = this.dataset.attributeKey;
      if (!key || !this.checkbox) return;

      const value = this.checkbox.checked ? this.checkbox.value : this.hiddenInput?.value || 'No';
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { [key]: value } }),
        keepalive: true
      }).catch(() => {});
    }
  }

  if (!window.customElements.get('cart-attribute-checkbox')) {
    window.customElements.define('cart-attribute-checkbox', CartAttributeCheckbox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-infinite-scroll"] && !Shopify.designMode) return;
  try {
    class CollectionInfiniteScroll extends HTMLElement {
    connectedCallback() {
      this.root = this.closest(this.dataset.rootSelector || '.collection') || this.parentElement;
      this.list = this.root?.querySelector(this.dataset.listSelector || 'product-list');
      this.pagination = this.root?.querySelector('nav.pagination');
      this.sentinel = this.querySelector('[data-infinite-scroll-sentinel]') || this;
      this.label = this.querySelector('[data-infinite-scroll-label]');
      this.nextUrl = this.dataset.nextUrl || this.pagination?.querySelector('a[rel="next"]')?.getAttribute('href') || '';
      this.loading = false;
      this.abortController = new AbortController();

      if (this.pagination) {
        this.pagination.setAttribute('hidden', '');
        this.pagination.setAttribute('aria-hidden', 'true');
      }

      if (!this.list || !this.nextUrl) {
        this.updateLabel();
        return;
      }

      this.updateLabel();
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.loadNext();
      }, {
        root: null,
        rootMargin: '400px 0px',
        threshold: 0
      });
      this.observer.observe(this.sentinel);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.abortController?.abort();
    }

    updateLabel() {
      if (!this.label) return;
      this.label.textContent = this.nextUrl ? 'Scroll for more' : '';
    }

    async loadNext() {
      if (this.loading || !this.nextUrl) return;
      this.loading = true;

      try {
        const section = this.closest('.shopify-section');
        const sectionId = section ? section.id.replace('shopify-section-', '') : '';
        const url = new URL(this.nextUrl, window.location.origin);
        url.hash = '';
        if (sectionId) url.searchParams.set('section_id', sectionId);

        const html = await (await fetch(url.toString(), { signal: this.abortController.signal })).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const listSelector = this.dataset.listSelector || 'product-list';
        const incomingList = doc.querySelector(listSelector);
        const incomingNext = doc.querySelector('a[rel="next"]');
        const skipSelector = this.dataset.skipSelector || '';

        if (incomingList) {
          for (const node of [...incomingList.children]) {
            if (skipSelector && node.matches?.(skipSelector)) continue;
            const imported = document.importNode(node, true);
            imported.removeAttribute('reveal-on-scroll');
            for (const el of imported.querySelectorAll('[reveal-on-scroll]')) {
              el.removeAttribute('reveal-on-scroll');
            }
            this.list.appendChild(imported);
          }
        }

        this.nextUrl = incomingNext ? incomingNext.getAttribute('href') : '';
        this.updateLabel();

        if (!this.nextUrl) {
          this.observer?.unobserve(this.sentinel);
          return;
        }

        requestAnimationFrame(() => {
          const rect = this.sentinel.getBoundingClientRect();
          if (rect.top < window.innerHeight + 400) this.loadNext();
        });
      } catch (error) {
        if (error?.name !== 'AbortError' && this.pagination) {
          this.pagination.removeAttribute('hidden');
          this.pagination.removeAttribute('aria-hidden');
        }
      } finally {
        this.loading = false;
      }
    }
  }

  if (!window.customElements.get('collection-infinite-scroll')) {
    window.customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
  }
  } catch(e) { console.error(e); }
})();

})();
